import * as angular from "angular";
import HttpServiceName, {HttpService} from "../http/http.service";
import {Endpoints} from "../../shared/config/constant.module";

export interface ChangePasswordService {
  changePassword: (data: ChangePasswordData) => angular.IPromise<any>;
}

export interface ChangePasswordData {
  id: string;
  password: string;
  passwordConfirm: string;
  oldPassword: string;
}

export default angular.module('aps.services.changepassword', [HttpServiceName])
  .service('changePwdService', function(httpService: HttpService): ChangePasswordService {
    let changePassword = (data: ChangePasswordData) => {
      return httpService.post(Endpoints.CHANGE_PASSWORD, data);
    };
    return {
      changePassword : changePassword
    };
  })
  .name;


// WEBPACK FOOTER //
// ./src/app/services/changePassword/changePassword.service.ts